module.exports = __webpack_public_path__ + "static/media/promo.a0d9ca44.svg";